import React from 'react';

import Upload from '../Upload';

import styled from 'styled-components';

import { AddOutline } from 'ui/components/Icon';
import { UploadProps } from 'antd/lib/upload';

// eslint-disable-next-line react/prop-types
const UploadButton = ({ text = '' }) => (
  <>
    <AddOutline />

    <div className='ant-upload-text'>{text}</div>
  </>
);

interface IMultiUpload extends UploadProps {
  canEdit?: boolean;
}

const MultiUpload = styled(({ canEdit = true, ...props }: IMultiUpload) => (
  <Upload multiple listType='picture-card' {...props}>
    {canEdit && <UploadButton />}
  </Upload>
))`
  .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {
    display: none;
  }

  .ant-upload.ant-upload-select-picture-card,
  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 64px;
    height: 64px;
  }
`;

export default MultiUpload;
